/**
 * Parses the search results and returns an array of page numbers given the current page, number of results, and results per page.
 *
 * Args:
 *      data (Object): the search data.
 *          results (Array): the actual search results.
 *          totalCount (Number): the total number of search results.
 *      pagesAtOnce (Number): the number of pages to show at once.
 *      pageSizeTerm (Number): results per page.
 *      pageTerm (Number): current page number.
 *
 * Returns:
 *      [Number]: An array of page numbers.
 *
 */
export function processPagination(data, pagesAtOnce, pageSizeTerm, pageTerm) {
    if (data) {
        try {
            let numArray = [];
            const half = Math.ceil((pagesAtOnce - 1) / 2);

            const totalResults = data && data.results ? data.results.totalCount : 0;

            if (totalResults < pagesAtOnce * pageSizeTerm || pageTerm < half) { // low results or beginning
                let i;
                let maxNumber = pagesAtOnce;

                if (Math.ceil(totalResults / pageSizeTerm) < pagesAtOnce) {
                    maxNumber = Math.ceil(totalResults / pageSizeTerm);
                }

                for (i = 1; i <= maxNumber; i++) {
                    numArray.push(i);
                }
            } else if (totalResults - (pagesAtOnce * pageSizeTerm) < (pageTerm + 1) * pageSizeTerm) { // end
                let i;

                for (i = 0; i < pagesAtOnce; i++) {
                    const lastPage = Math.ceil(totalResults / pageSizeTerm);
                    numArray.push(lastPage - i);
                }

                numArray = numArray.reverse();
            } else { // middle
                let i;

                for (i = pageTerm + 1 - half; i <= pageTerm + 1 + half; i++) {
                    numArray.push(i);
                }
            }

            return numArray;
        } catch (ex) {
            // error
        }
    }

    return [];
}
